<div class="header-banner">
    @if (showContent) {
      <div class="header-banner__content" [class.header-banner__content--only-description]="!bannerText && bannerDescription">
        @if (bannerText) {
          <div class="header-banner__text">{{ bannerText | translate }}</div>
        }
        @if (bannerDescription) {
          <div class="header-banner__description">{{ bannerDescription | translate }}</div>
        }
      </div>
    }
    <div class="header-banner__img" [style.background-image]="'url(' + bannerImageUrl + ')'"></div>

  @if(breakpointService.isDesktop()) {
    @if(!disableBackToPlan) {
      <button class="header-banner__back-to-planner" [routerLink]="[ERoutes.SLASH, ERoutes.TRIP_PLANNER]">
        <p>{{'BUTTONS.BACK_TO_PLANNER' | translate}}</p>
      </button>
    }
  }
</div>
